import React from 'react';
import styled from '@emotion/styled';

const SeparatorContainer = styled.li`
  margin: 0px 8px;

  + li {
    margin-top: 0px;
  }
`;

const Bull = () => <SeparatorContainer role="presentation">&bull;</SeparatorContainer>;

export default Bull;
